import './TabViewHeader.css'

import { IonButtons, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/react'
import { useT } from '@transifex/react'

export default function TabViewHeader({ title, shouldHideHeaderTextAndColor }: { title: string; shouldHideHeaderTextAndColor: boolean }) {
  const t = useT()

  return (
    <IonHeader className="tab-view-header ion-no-border">
      <IonToolbar className={shouldHideHeaderTextAndColor ? 'ion-no-border' : ''} color={shouldHideHeaderTextAndColor ? 'transparent' : ''}>
        <IonButtons slot="start">
          <IonMenuButton disabled className="text-transparent" />
        </IonButtons>
        <IonTitle>{!shouldHideHeaderTextAndColor && t(title)}</IonTitle>
        <IonButtons slot="end">
          <IonMenuButton />
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  )
}
